import styled, { css } from 'styled-components';

type ContainerProps = {
  isCheck: boolean;
};
export const Container = styled.div<ContainerProps>`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #dadada;
  border-radius: 8px;

  svg {
    color: #dadada;
  }

  & + div {
    margin-left: 12px;

    @media (max-width: 768px) {
      margin-left: 6px;
    }
  }

  ${({ isCheck }) =>
    isCheck &&
    css`
      border: 1px solid #0b29fb;
      border-radius: 8px;

      svg {
        color: #0b29fb;
      }
    `}
`;
